import React, { useState, useRef } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CToast,
  CToastHeader,
  CToastBody,
  CToaster,
  CCol,
  CRow,
  CFormLabel,
  CFormTextarea,
} from "@coreui/react";

const CommentModal = ({
  visible,
  setVisibleCommentModal,
  addToast,
  onConfirm,
  errorText,
  handleReportComment,
  reportComment,
}) => {
  const exampleToast = (
    <CToast>
      <CToastHeader closeButton>
        <svg
          className="rounded me-2"
          width="20"
          height="20"
          xmlns="http://www.w3.org/2000/svg"
          preserveAspectRatio="xMidYMid slice"
          focusable="false"
          role="img"
        >
          <rect width="100%" height="100%" fill="#007aff"></rect>
        </svg>
        <div className="fw-bold me-auto">CoreUI for React.js</div>
        <small>7 min ago</small>
      </CToastHeader>
      <CToastBody>Hello, world! This is a toast message.</CToastBody>
    </CToast>
  );
  const closeModal = () => {
    setVisibleCommentModal(false);
  };
  const deleteFn = () => {
    addToast(exampleToast);
    setVisibleCommentModal(false);
  };
  return (
    <div>
      <CModal
        backdrop="static"
        visible={visible}
        onClose={() => {
          onConfirm("cancel");
        }}
      >
        <CModalHeader onClose={() => onConfirm("cancel")}>
          <CModalTitle>Add Your Comment</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <CCol sm={12}>
            <CRow className="mb-3">
              <CCol sm={12}>
                <CFormTextarea
                  id="exampleFormControlTextarea1"
                  rows={3}
                  onChange={handleReportComment}
                  value={reportComment}
                ></CFormTextarea>
                {errorText ? <p className="error_text">{errorText}</p> : ""}
              </CCol>
            </CRow>
          </CCol>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => onConfirm("cancel")}>
            Close
          </CButton>
          <CButton
            color="danger"
            onClick={() => onConfirm("confirm")}
            disabled={!reportComment}
          >
            Confirm
          </CButton>
        </CModalFooter>
      </CModal>
    </div>
  );
};

export default CommentModal;
